export enum BusinessType {
  Individual = "individual",
  Corporate = "corporate",
}
